// extracted by mini-css-extract-plugin
module.exports = {"mdBreakPoint":"992","container":"_1DUJuZXIrAAb5cgG","text":"rVeY04IFd7NKRcBV"};